import { wrapProperty } from "@nuxtjs/composition-api";

/**
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 *
 * @function useAxios
 * @desc     A composable that merely wraps the $axios plugin into a
 *           simple accessor. This may have a native composable in the
 *           future. might remove.
 *
 * @summary  Composable used to access Axios plugin
 *
 ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 */

export const useAxios = wrapProperty("$axios", false);
